const i18n = require('i18n');

const LandscapePrefix = 'G';
const PortraitPrefix = 'V';
const AudioMap = require('AudioMap');

cc.Class({
    extends: cc.Component,

    properties: {
        label1: cc.Node,
        label2: cc.Node,
        label1Portrait: cc.Node,
        label2Portrait: cc.Node,
        skeleton: sp.Skeleton,
        overlay: cc.Node,
    },

    onLoad() {
        this.prefix = LandscapePrefix;
        this.audioMap = cc.find('AudioMap').getComponent(AudioMap);
        this.skeleton.setCompleteListener((event) => {
            switch(this.skeleton.animation) {
                case 'Gstart':
                case 'Vstart':

                    break;
            }
            this._playAnim('idle');
        });
    },

    show() {
        this.node.active = true;
        this.node.opacity = 255;

        this.overlay.opacity = 0;
        cc.tween(this.overlay).to(1, { opacity: 230 }).start();
        // this._playAnim('start');
        this.isFirstTime = true;
        this.audioMap.playSfx('fsIntroAppears');
        this.scheduleOnce(() => this.node.emit('show'), 2);
        this.screenRect = cc.view.getVisibleSize();
        const aspect = this.screenRect.width / this.screenRect.height;

        if (aspect < .8) {
            this.onPortrait();
        }
        if (aspect >= .8) {
            this.onLandscape();
        }
        // this.label.string = i18n.t('you-won-fs', { 0: '\n15' });

    },

    onLandscape() {
        this.prefix = LandscapePrefix;
        this.node.y = 100;
        this.label1.active = true;
        this.label2.active = true;
        this.label1Portrait.active = false;
        this.label2Portrait.active = false;

        if (this.node.active ) {
            if (!this.isFirstTime) {
                this._playAnim('idle');
            } else {
                this._playAnim('start');
                this.isFirstTime = false;
            }
        }
    },
    onPortrait() {
        this.node.y = 0;
        this.label1Portrait.active = true;
        this.label2Portrait.active = true;
        this.label1.active = false;
        this.label2.active = false;

        this.prefix = PortraitPrefix;
        if (this.node.active ) {
            if (!this.isFirstTime) {
                this._playAnim('idle');
            } else {
                this._playAnim('start');
                this.isFirstTime = false;
            }
        }
    },

    _playAnim(animName = null) {
        animName = animName || this._currentAnimName;

        this._currentAnimName = animName;

        this.skeleton.setAnimation(0, `${this.prefix}${this._currentAnimName}`);
    },

    hide() {
        cc.tween(this.node).to(0.3, { opacity: 0 }).call(() => {
            this.node.active = false;
        }).start();
    }
});
